module.exports = __webpack_public_path__ + "static/media/Timetable 3up 2 columns.001 (1).dcb66d7f.jpeg";